
import { defineComponent, onBeforeMount, reactive } from 'vue'

// composable
import { useRoute } from 'vue-router'
import useNotifications from '@/common/composable/useNotifications'

// types
import { FTLTTNI } from '@/core/types/ftl.types'

// realisations
import { FTL } from '@/core/realisations/FTL.realisation'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    setup() {
        const route = useRoute()
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            is_failed: true,
            ttn: null as null | FTLTTNI,
        })

        const ttn_id = Number(route.params.ttn_id as string)

        const loadTTN = async () => {
            try {
                state.is_loading = true

                const response = await FTL.printTTN(ttn_id)
                state.ttn = response.data

                setTimeout(window.print, 500)

                state.is_failed = false
            } catch (error) {
                notifications.notifyError({ error, title: 'Ошибка получения данных ТТН' })
                state.is_failed = true
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadTTN)

        return { state, loadTTN }
    },
})
